/**
 * Offer Create page module.
 * Refactored to use shared modules for cascading dropdowns and group visibility.
 */

import { setupCascadingDropdown } from '../lib/cascading-dropdown';
import { setupContactPersonDropdown } from '../lib/contact-dropdown';
import { applyGroupVisibility } from '../modules/offer/group-visibility';
import { populateInsuranceDropdowns } from '../modules/offer/insurance-config';
import type { OfferTypeItem, ConfigItem } from '../lib/types';

document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('create-offer-form') as HTMLFormElement | null;
    if (!form) return;

    const getUsersUrl = form.dataset.urlUsersForAgency || '';
    const offerTypes: OfferTypeItem[] = JSON.parse(form.dataset.offerTypes || '[]');
    const insuranceUnitTypes: ConfigItem[] = JSON.parse(form.dataset.insuranceUnitTypes || '[]');

    const groupSelect = document.getElementById('OfferGroup') as HTMLSelectElement | null;
    const typeSelect = document.getElementById('OfferTypeId') as HTMLSelectElement | null;
    const agencySelect = document.getElementById('AgencyId') as HTMLSelectElement | null;

    if (!groupSelect || !typeSelect || !agencySelect) return;

    const insuranceUnitTypeSelect = document.getElementById('InsuranceOfferUnitTypeId') as HTMLSelectElement | null;

    // Setup cascading Group → Type dropdown
    setupCascadingDropdown({
        groupSelect,
        typeSelect,
        offerTypes,
        onGroupChange: (selectedGroup) => {
            applyGroupVisibility(selectedGroup, {
                transportSection: document.getElementById('transport-price-section'),
                insuranceSection: document.getElementById('insurance-section'),
                profileImageSection: document.getElementById('profile-image-section'),
                contactFieldsSection: document.getElementById('contact-fields-section')
            }, {
                populateInsuranceDropdowns: () => populateInsuranceDropdowns({
                    unitTypeSelect: insuranceUnitTypeSelect,
                    unitTypes: insuranceUnitTypes
                })
            });
        }
    });

    // Setup Agency → Contact Person dropdown
    setupContactPersonDropdown({
        agencySelect,
        containerElementId: 'dependentDropdownContainer',
        getUsersUrl,
        preselectedAgencyId: agencySelect.value || undefined,
    });
});
